// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/antd-customize/modal.css
// module id = 984
// module chunks = 0